/**
 * Constants are important - they describe what type of action is performed
 * within your app. Combined with the DevTools/logger, you can see how state and subsequently
 * your UI is being affected.
 */
 
export const UPDATE_BENCHMARK = 'UPDATE_BENCHMARK';



/** WEBPACK FOOTER **
 ** ./src/constants/ActionTypes.js
 **/